var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgXIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9998 1C12.8123 0.81253 12.558 0.707214 12.2928 0.707214C12.0277 0.707214 11.7733 0.81253 11.5858 1L6.99982 5.586L2.41382 1C2.22629 0.81253 1.97198 0.707214 1.70682 0.707214C1.44165 0.707214 1.18735 0.81253 0.999818 1C0.812347 1.18753 0.707031 1.44184 0.707031 1.707C0.707031 1.97217 0.812347 2.22647 0.999818 2.414L5.58582 7L0.999818 11.586C0.812347 11.7735 0.707031 12.0278 0.707031 12.293C0.707031 12.5582 0.812347 12.8125 0.999818 13C1.18735 13.1875 1.44165 13.2928 1.70682 13.2928C1.97198 13.2928 2.22629 13.1875 2.41382 13L6.99982 8.414L11.5858 13C11.7733 13.1875 12.0277 13.2928 12.2928 13.2928C12.558 13.2928 12.8123 13.1875 12.9998 13C13.1873 12.8125 13.2926 12.5582 13.2926 12.293C13.2926 12.0278 13.1873 11.7735 12.9998 11.586L8.41382 7L12.9998 2.414C13.1873 2.22647 13.2926 1.97217 13.2926 1.707C13.2926 1.44184 13.1873 1.18753 12.9998 1Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXIcon);
export default __webpack_public_path__ + "static/media/X-icon.62652ec24a757dc2132e4fc7ccb62941.svg";
export { ForwardRef as ReactComponent };